var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownOpenProtocol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9848 1.68457H3.99176C2.21506 1.68457 0.769531 3.12982 0.769531 4.9068V15.3062C0.769531 17.0792 2.20877 18.5221 3.98031 18.5284V23.2475L10.7622 18.5284H20.9848C22.7615 18.5284 24.207 17.0829 24.207 15.3062V4.9068C24.207 3.12982 22.7615 1.68457 20.9848 1.68457ZM22.8337 15.3062C22.8337 16.3256 22.0043 17.1551 20.9848 17.1551H10.3314L5.3536 20.619V17.1551H3.99176C2.97223 17.1551 2.14282 16.3256 2.14282 15.3062V4.9068C2.14282 3.88713 2.97223 3.05786 3.99176 3.05786H20.9848C22.0043 3.05786 22.8337 3.88713 22.8337 4.9068V15.3062Z",
    fill: "#364863"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04102 6.53711H17.9326V7.9104H7.04102V6.53711Z",
    fill: "#364863"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04102 9.4668H17.9326V10.8401H7.04102V9.4668Z",
    fill: "#364863"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04102 12.3965H17.9326V13.7698H7.04102V12.3965Z",
    fill: "#364863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownOpenProtocol);
export default __webpack_public_path__ + "static/media/dropdown-open-protocol.4824132769d79b9e6c436adaa89dcee1.svg";
export { ForwardRef as ReactComponent };